export interface RecentCard {
  id: string;
  title: string;
  human_id: string | null;
}

const RECENTS_KEY = 'agentboard.recentCards.v1';
const RECENTS_EVENT = 'agentboard:recent-cards-updated';

export function loadRecentCards(): RecentCard[] {
  try {
    const raw = localStorage.getItem(RECENTS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function pushRecentCard(card: RecentCard): void {
  const list = loadRecentCards().filter((recent) => recent.id !== card.id);
  list.unshift(card);
  const next = list.slice(0, 5);

  try {
    localStorage.setItem(RECENTS_KEY, JSON.stringify(next));
  } catch {
    // Ignore storage failures; recents are opportunistic.
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(RECENTS_EVENT, { detail: next }));
  }
}

export function onRecentCardsUpdated(listener: (items: RecentCard[]) => void): () => void {
  if (typeof window === 'undefined') return () => {};

  const handle = (event: Event) => {
    const items = (event as CustomEvent<RecentCard[]>).detail ?? loadRecentCards();
    listener(items);
  };

  window.addEventListener(RECENTS_EVENT, handle);
  return () => {
    window.removeEventListener(RECENTS_EVENT, handle);
  };
}
